import { pdfUrl } from "./api/client";
import './App.css';
import React, {useEffect, useRef, useState} from "react";

import 'react-toastify/dist/ReactToastify.css';
import Popover from '@mui/material/Popover';

// Aynı anda tek hover popover — teklifler arası geçişte birikmesin
let activeHoverId = 0;
let activeHardClose = null;

export default function MalzemeListesiOnizleme(props) {

    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [teklif_no, setTeklif_no] = useState(null);
    const openTimer = useRef(0);
    const closeTimer = useRef(0);
    const hoverId = useRef(++activeHoverId);

    // Teklif tarihini kontrol et - 07.01.2026 ve sonrası için MRP linkleri kullan
    const shouldUseMrpVersion = () => {
        if (!props.teklifTarihi) return false;

        const cutoffDate = new Date('2026-01-07');
        let teklifDate;

        // Farklı tarih formatlarını destekle
        if (props.teklifTarihi.includes('.')) {
            // DD.MM.YYYY formatı
            const parts = props.teklifTarihi.split('.');
            teklifDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
        } else if (props.teklifTarihi.includes('-')) {
            // YYYY-MM-DD formatı
            teklifDate = new Date(props.teklifTarihi);
        } else {
            return false;
        }

        return teklifDate >= cutoffDate;
    };

    const pdfLang = () => {
        const d = String(props.teklifDili || '').trim().toLowerCase();
        return (d === 'english' || d === 'en' || d === 'ingilizce' || d === 'eng') ? 'en' : 'tr';
    };

    // Hover: HTML malzeme listesi (Python). Click: PDF.
    const malzemeListesiSrc = (no) =>
        pdfUrl(`malzeme/${encodeURIComponent(no || '')}?mrp=${shouldUseMrpVersion()}&lang=${pdfLang()}`);

    const teklifPdfHref = () =>
        pdfUrl(`teklif/${props.teklifNo}?mrp=${shouldUseMrpVersion()}&lang=${pdfLang()}`);

    const clearTimers = () => {
        clearTimeout(openTimer.current);
        clearTimeout(closeTimer.current);
    };

    const keepOpen = () => {
        clearTimeout(closeTimer.current);
    };

    const hardClose = () => {
        clearTimers();
        setOpen(false);
        setAnchorEl(null);
        setTeklif_no(null);
        if (activeHardClose === hardClose) activeHardClose = null;
    };

    const scheduleClose = () => {
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(hardClose, 350);
    };

    // iframe'e girince paper mouseleave relatedTarget=null → kapatma.
    const onPaperLeave = (e) => {
        if (e.relatedTarget == null) return;
        scheduleClose();
    };

    useEffect(() => {
        const onMsg = (ev) => {
            if (ev?.data?.type !== 'malzeme-hover-leave') return;
            if (activeHardClose === hardClose) scheduleClose();
        };
        window.addEventListener('message', onMsg);
        return () => {
            window.removeEventListener('message', onMsg);
            if (activeHardClose === hardClose) activeHardClose = null;
            clearTimers();
        };
    }, []);

    function popupOpen(event) {
        // Başka teklifin popover'ı açıksa hemen kapat
        if (activeHardClose && activeHardClose !== hardClose) {
            try { activeHardClose(); } catch (e) {}
        }
        activeHardClose = hardClose;
        keepOpen();
        setAnchorEl(event.currentTarget);
        setTeklif_no(event.currentTarget.id || props.teklifNo);
        clearTimeout(openTimer.current);
        openTimer.current = setTimeout(() => {
            keepOpen();
            setOpen(true);
        }, 400);
    }

    function mouseLeaveLink() {
        clearTimeout(openTimer.current);
        scheduleClose();
    }

    return (
        <div>
            <Popover
                id={`mouse-over-popover-${hoverId.current}`}
                open={open}
                anchorEl={anchorEl}
                hideBackdrop
                disableScrollLock
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                // Backdrop/root mouse'u yutmasın; sadece paper etkileşim alsın
                sx={{ pointerEvents: 'none' }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                }}
                onClose={hardClose}
                PaperProps={{
                    onMouseEnter: keepOpen,
                    onMouseLeave: onPaperLeave,
                    sx: {
                        pointerEvents: 'auto',
                        overflow: 'hidden',
                        maxWidth: 'min(920px, 96vw)',
                        maxHeight: 'min(70vh, 560px)',
                    },
                }}
            >
                 <iframe
                    title="Malzeme listesi"
                    width={880}
                    height={520}
                    style={{ display: 'block', border: 0, maxWidth: '100%' }}
                    src={teklif_no ? malzemeListesiSrc(teklif_no) : undefined}
                 />
            </Popover>
            <a href={teklifPdfHref()}
               target={'_blank'}
               rel="noreferrer"
               aria-owns={open ? `mouse-over-popover-${hoverId.current}` : undefined}
               aria-haspopup="true"
               onMouseEnter={popupOpen}
               onMouseLeave={mouseLeaveLink}
               id={props.teklifNo}
            >{props.teklifNo}</a>
        </div>
    );
}
